import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=09c57367&scoped=true"
import script from "./BrandList.vue?vue&type=script&lang=js"
export * from "./BrandList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c57367",
  null
  
)

export default component.exports